/**
 * Lazy autoplay videos.
 *
 * snippets/kik-video-sources.liquid (lazy: true) renders <source data-src>, so
 * nothing downloads at page load. Each <video> gets its real src only once it
 * is on screen; videos hidden with display:none (the mobile copy on desktop
 * and vice versa) never intersect and therefore never download.
 */
(function () {
  function load(video) {
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute('data-src');
      sources[i].removeAttribute('data-src');
    }
    video.load();
    if (video.autoplay) {
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }
  }

  function init() {
    var videos = [];
    var sources = document.querySelectorAll('video source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      var video = sources[i].parentNode;
      if (videos.indexOf(video) === -1) videos.push(video);
    }
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(load);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Sections re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
